import { useApi } from "./api"
import { ErrorDialog } from "./components/ErrorDialog";
import { ICargo } from "./interfaces";

export const Utils = () => {
  const projectCode = 'NFT';
  const api = useApi(projectCode);
  return {
    isLogin() {
      return localStorage.getItem('token') ? true : false
    },
    checkKyc(projectCode?: string) {
      api.getKycStatus((cargo: ICargo) => {
        if (cargo.returnCode === '000000') {
          if (cargo.info['kycStatus'] !== 2) {
            ErrorDialog({title: "請先完成實名認證", cb: () => {
              if (projectCode) {
                window.location.href = `/store/${projectCode}/profile`
              } else {
                window.location.href = '/web/profile'
              }
            }})
          }
        }
      })
    },
    normalizeImagePath(path: string, projectCode?: string) {
      if (!path) return path;
      if (path.indexOf('http') > -1) {
        return path
      } else {
        if (projectCode) {
          return `https://file.sup.me.uk/${projectCode.toLocaleLowerCase()}/${path}`
        }
        return `https://file.sup.me.uk/${path}`
      }
    },
    uuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3) | 0x8; return v.toString(16); });
    },
    getNftDetailPath(nftId: string) {
      return `/web/asset/detail/${nftId}`
    },
    normalizeHexAddress(address?: string) {
      if (!address) return '';
      return `0x${address.replace('0x', '')}`
    }
  }
}